import React from 'react';
import { Box } from '@mui/material';

interface ReconnectingDotsProps {
  size?: number; // Tamaño de cada dot
  color?: string; // Color de los dots
  spacing?: number; // Espacio entre dots
}

/**
 * Componente de animación de 3 dots que crecen/decrecen secuencialmente
 * Usado para indicar que el WebSocket se está reconectando
 */
const ReconnectingDots: React.FC<ReconnectingDotsProps> = ({ 
  size = 6, 
  color = '#2391FF', // Azul usado en la app
  spacing = 4 
}) => {
  console.log('[ReconnectingDots] Renderizando dots, size:', size, 'color:', color);
  
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: `${spacing}px`,
        width: '100%',
        height: '100%',
        position: 'relative',
        zIndex: 10,
      }}
    >
      {[0, 1, 2].map((index) => (
        <Box
          key={index}
          sx={{
            width: `${size}px`,
            height: `${size}px`,
            borderRadius: '50%',
            backgroundColor: color,
            animation: 'pulse-dot 1.2s ease-in-out infinite',
            animationDelay: `${index * 0.2}s`,
            '@keyframes pulse-dot': {
              '0%, 100%': {
                transform: 'scale(0.8)',
                opacity: 0.6,
              },
              '50%': {
                transform: 'scale(1.2)',
                opacity: 1,
              },
            },
          }}
        />
      ))}
    </Box>
  );
};

export default ReconnectingDots;

